module.exports = ":host .tile a {\n  font-size: 1.375rem;\n  opacity: .7; }\n  :host .tile a:hover {\n    opacity: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/asset-delete/asset-delete.component.scss
// module id = ./src/app/shared/components/asset-delete/asset-delete.component.scss
// module chunks = main